import { HttpClient } from "@angular/common/http";

import { Component, OnInit } from "@angular/core";
import { SimpleTimer } from "ng2-simple-timer";
import { LocalDataSource } from "ng2-smart-table";
import { NbToastrService } from "@nebular/theme";
import { MENU_ITEMS } from "./pages/pages-menu";
import { SV_URL } from "./@core/utils/utils";
import { UtilsProvider } from "./@shared/services/utils.service";
import { BnNgIdleService } from "bn-ng-idle";
import { SessionExpiryService } from "./@core/services/session-expiry.service";
import { CredentiaisService } from "./@core/utils/credentials.service";
import { PermissionService } from "./@core/services/permission.service";

@Component({
  selector: "ngx-app",
  template: "<router-outlet></router-outlet><ngx-ui-loader></ngx-ui-loader>",
})
export class AppComponent implements OnInit {
  counter0 = 0;
  timer0Id: string;
  seq0: string;
  sourcePecas: LocalDataSource = new LocalDataSource();

  counter1 = 0;
  timer1Id: string;
  seq1: string;
  sourcePre: LocalDataSource = new LocalDataSource();

  counter2 = 0;
  timer2Id: string;
  seq2: string;
  sourceDesc: LocalDataSource = new LocalDataSource();

  dia = new Date();

  menu = MENU_ITEMS;

  menuVendas: Array<any> = [];
  menuLancamentos: Array<any> = [];
  menuRelatorios: Array<any> = [];
  menuAdmin: Array<any> = [];
  menuCambio: Array<any> = [];
  menuAstral: Array<any> = [];

  constructor(
    private st: SimpleTimer,
    private toastr: NbToastrService,
    public http: HttpClient,
    private bnIdle: BnNgIdleService,
    private sessionExpiry: SessionExpiryService,
    public utils: UtilsProvider,
    private credentials: CredentiaisService,
    private permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.verificaOrigem();
    this.st.newTimer("1sec", 1, true);
    this.timerSessao();
    this.carregarMenus();
  }

  verificaOrigem() {
    const ua = navigator.userAgent;
    const qp = window.location.href
    // if (ua.includes('Electron') || qp.includes('localhost') || qp.includes('rlx'))  {
    //   console.log('entrou');
    // } else {
    //   document.body.innerHTML = '';
    //   window.location.href = "https://www.google.com";
    // }
  }

  timerSessao() {
    sessionStorage.removeItem("actsit");
    if (sessionStorage.getItem("portal")) {
      console.log("timer iniciado");
      this.bnIdle.startWatching(3600).subscribe((isTimedOut: boolean) => {
        const act = sessionStorage.getItem("actsit");
        if (isTimedOut && act !== "005") {
          sessionStorage.setItem("actsit", "005"); // timeout
          this.bnIdle.stopTimer();
          this.bnIdle.resetTimer();
          this.modalSessaoExpirada();
        }
      });
    }
  }

  subscribeTimerPecas(seq) {
    this.seq0 = seq;
    if (seq) {
      if (this.timer0Id) {
        this.st.unsubscribe(this.timer0Id);
        this.timer0Id = undefined;
      } else {
        this.timer0Id = this.st.subscribe("1sec", () =>
          this.timer0callback(seq)
        );
      }
    } else {
      this.toastr.danger("Selecione a Peça", "Atenção");
    }
  }

  timer0callback(seq): void {
    let time = 2700;

    if (this.dia.getDay() === 6 || this.dia.getDay() === 3) {
      if (seq === "4") {
        time = 5400;
      }
    }

    if (this.counter0 === time) {
      this.st.unsubscribe(this.timer0Id);
      this.counter0 = 0;
      this.seq0 = "";
      this.sourcePecas = new LocalDataSource();
    } else {
      this.counter0++;
    }
  }

  subscribeTimerPre(seq) {
    this.seq1 = seq;
    if (seq) {
      if (this.timer1Id) {
        this.st.unsubscribe(this.timer1Id);
        this.timer1Id = undefined;
      } else {
        this.timer1Id = this.st.subscribe("1sec", () =>
          this.timer1callback(seq)
        );
      }
    } else {
      this.toastr.danger("Selecione a Peça", "Atenção");
    }
  }

  timer1callback(seq): void {
    let time = 2700;

    if (this.dia.getDay() === 6 || this.dia.getDay() === 3) {
      if (seq === "4") {
        time = 5400; // 1:30h
      }
    }

    if (this.counter1 === time) {
      this.st.unsubscribe(this.timer1Id);
      this.counter1 = 0;
      this.seq1 = "";
      this.sourcePre = new LocalDataSource();
    } else {
      this.counter1++;
    }
  }

  subscribeTimerDesc(seq) {
    this.seq2 = seq;
    if (seq) {
      if (this.timer2Id) {
        this.st.unsubscribe(this.timer2Id);
        this.timer2Id = undefined;
      } else {
        this.timer2Id = this.st.subscribe("1sec", () =>
          this.timer2callback(seq)
        );
      }
    } else {
      this.toastr.danger("Selecione a Peça", "Atenção");
    }
  }

  timer2callback(seq): void {
    let time = 2700;

    if (this.dia.getDay() === 6 || this.dia.getDay() === 3) {
      if (seq === "4") {
        time = 5400;
      }
    }

    if (this.counter2 === time) {
      this.st.unsubscribe(this.timer2Id);
      this.counter2 = 0;
      this.seq2 = "";
      this.sourceDesc = new LocalDataSource();
    } else {
      this.counter2++;
    }
  }

  carregarMenus() {
    if (sessionStorage.getItem("uid")) {
      const perms = this.permissionService.getPermissions();

      this.menu[1].hidden = true;
      this.menu[2].hidden = !perms.gestao?.acesso;
      this.menu[3].hidden = true;
      this.menu[4].hidden = true;

      this.carregaVendas(perms);
      this.carregaLancamentos(perms);
      this.carregaRelatorios(perms);
      this.carregaCambio(perms);
      this.carregaAstral(perms);
    }
  }

  carregaVendas(perms: any) {
    this.menuVendas = [];
    const v = perms.vendas || {};

    if (v.cheque) {
      this.menuVendas.push({ title: "Cheque", icon: "credit-card-outline", link: "/pages/sales/cheque" });
    }
    if (v.deu) {
      this.menuVendas.push({ title: "Deu", icon: "download-outline", link: "/pages/sales/deu-sales" });
    }
    if (v.deu_aberto) {
      this.menuVendas.push({ title: "Deu em Aberto", icon: "checkmark-square-outline", link: "/pages/sales/deu-aberto" });
    }
    if (v.descarga) {
      this.menuVendas.push({ title: "Descarga", icon: "arrowhead-right-outline", link: "/pages/sales/descarga" });
    }
    if (v.envio) {
      this.menuVendas.push({ title: "Envio", icon: "arrow-circle-right-outline", link: "/pages/sales/envio" });
    }
    if (v.folgas) {
      this.menuVendas.push({ title: "Folgas", icon: "calendar-outline", link: "/pages/sales/folgas" });
    }
    if (v.pecas) {
      this.menuVendas.push({ title: "Peças", icon: "edit-2-outline", link: "/pages/sales/new-sales" });
    }
    if (v.premios) {
      this.menuVendas.push({ title: "Prêmios", icon: "award-outline", link: "/pages/sales/premios" });
    }
    if (v.rcc) {
      this.menuVendas.push({ title: "RCC", icon: "message-circle-outline", link: "/pages/sales/rcc" });
    }
    if (v.vendedores) {
      this.menuVendas.push({ title: "Vendedores", icon: "people-outline", link: "/pages/sales/vendedores" });
    }
    if (v.coringa) {
      this.menuVendas.push({ title: "Coringa", icon: "bulb-outline", link: "/pages/sales/coringa" });
    }
    if (v.despesas) {
      this.menuVendas.push({ title: "Despesas", icon: "swap-outline", link: "/pages/sales/despesas" });
    }
    if (v.folha) {
      this.menuVendas.push({ title: "Folha", icon: "file-text-outline", link: "/pages/sales/folha" });
    }

    if (this.menuVendas.length > 0) {
      this.menu[1].hidden = false;
    }
  }

  carregaRelatorios(perms: any) {
    this.menuRelatorios = [];
    const r = perms.relatorios || {};

    if (r.cheque) {
      this.menuRelatorios.push({ title: "Cheques", icon: "credit-card-outline", link: "/pages/reports/cheque-report" });
    }
    if (r.conferencia) {
      this.menuRelatorios.push({ title: "Conferência", icon: "people-outline", link: "/pages/reports/conferencia-report" });
    }
    if (r.coringa) {
      this.menuRelatorios.push({ title: "Coringa", icon: "bulb-outline", link: "/pages/reports/coringa-report" });
    }
    if (r.descarga) {
      this.menuRelatorios.push({ title: "Descarga", icon: "arrowhead-right-outline", link: "/pages/reports/descarga-report" });
    }
    if (r.despesas) {
      this.menuRelatorios.push({ title: "Despesas", icon: "swap-outline", link: "/pages/reports/despesas-report" });
    }
    if (r.deu) {
      this.menuRelatorios.push({ title: "Deu", icon: "download-outline", link: "/pages/reports/deu-report" });
    }
    if (r.deu_aberto) {
      this.menuRelatorios.push({ title: "Deu em Aberto", icon: "checkmark-square-outline", link: "/pages/reports/deu-aberto-report" });
    }
    if (r.envio) {
      this.menuRelatorios.push({ title: "Envio", icon: "arrow-circle-right-outline", link: "/pages/reports/envio-report" });
    }
    if (r.planilha) {
      this.menuRelatorios.push({ title: "Planilha Lot", icon: "layout-outline", link: "/pages/reports/loteReport" });
      this.menuRelatorios.push({ title: "Planilha Lot V2", icon: "layout-outline", link: "/pages/reports/lote-v2-report" });
      this.menuRelatorios.push({ title: "Geral V2", icon: "grid-outline", link: "/pages/reports/geral-v2" });
    }
    if (r.premios) {
      this.menuRelatorios.push({ title: "Prêmios", icon: "award-outline", link: "/pages/reports/premios-report" });
    }
    if (r.premios_data) {
      this.menuRelatorios.push({ title: "Prêmio Datas", icon: "award-outline", link: "/pages/reports/premios-range-report" });
    }
    if (r.rcc) {
      this.menuRelatorios.push({ title: "RCC", icon: "message-circle-outline", link: "/pages/reports/rcc-report" });
    }
    if (r.vendedores) {
      this.menuRelatorios.push({ title: "Vendedores", icon: "people-outline", link: "/pages/reports/vendedores" });
    }

    if (this.menuRelatorios.length > 0) {
      this.menu[3].hidden = false;
    }
  }

  carregaLancamentos(perms: any) {
    this.menuLancamentos = [];
    const l = perms.lancamentos || {};

    if (l.pecas) {
      this.menuLancamentos.push({ title: "Peças", icon: "plus-square-outline", link: "/pages/sales/new-sales-basic" });
    }
    if (l.premios) {
      this.menuLancamentos.push({ title: "Prêmios", icon: "plus-circle-outline", link: "/pages/sales/premios-basic" });
    }
    if (l.descarga) {
      this.menuLancamentos.push({ title: "Descarga", icon: "arrowhead-right-outline", link: "/pages/sales/descarga-basic" });
    }
    if (l.mapa) {
      this.menuLancamentos.push({ title: "Mapa Milhar", icon: "map", link: "/pages/sales/mapa_milhar" });
    }
    if (l.mapa) {
      this.menuLancamentos.push({ title: "Mapa Centena", icon: "map", link: "/pages/sales/mapa_centena" });
    }
    if (l.pecas) {
      this.menuLancamentos.push({ title: "Peças V2", icon: "cube-outline", link: "/pages/sales/pecas-basic-v2" });
    }
    if (l.resultados) {
      this.menuLancamentos.push({ title: "Resultados", icon: "alert-circle-outline", link: "/pages/sales/resultBasic" });
    }

    if (this.menuLancamentos.length > 0) {
      this.menu[4].hidden = false;
    }
  }

  carregaCambio(perms: any) {
    this.menuCambio = [];
    const c = perms.cambio || {};

    if (c.vendedores) {
      this.menuCambio.push({ title: "Vendedores", icon: "people-outline", link: "/pages/cambio/vendedores" });
    }
    if (c.ferias) {
      this.menuCambio.push({ title: "Férias", icon: "edit-2-outline", link: "/pages/cambio/ferias" });
    }
    if (c.premios) {
      this.menuCambio.push({ title: "Prêmios", icon: "award-outline", link: "/pages/cambio/premios" });
    }
    if (c.deu) {
      this.menuCambio.push({ title: "Deu", icon: "download-outline", link: "/pages/cambio/deu" });
    }
    if (c.envios) {
      this.menuCambio.push({ title: "Envios", icon: "arrow-circle-right-outline", link: "/pages/cambio/envios" });
    }
    if (c.extrato) {
      this.menuCambio.push({ title: "Movimento", icon: "file-text-outline", link: "/pages/cambio/extrato-diario" });
    }
    if (c.rela_ferias) {
      this.menuCambio.push({ title: "Relatório Férias", icon: "file-text-outline", link: "/pages/cambio/rela-ferias" });
    }

    if (this.menuCambio.length > 0) {
      this.menu[3].hidden = false;
    }
  }

  carregaAstral(perms: any) {
    this.menuAstral = [];
    const a = perms.astral || {};

    if (a.fotos) {
      this.menuAstral.push({ title: "Fotos", icon: "file-text-outline", link: "/pages/astral/send" });
    }
    if (a.usuarios) {
      this.menuAstral.push({ title: "Usuários", icon: "people-outline", link: "/pages/astral/user" });
    }
    if (a.usuarios) {
      this.menuAstral.push({ title: "Categorias", icon: "people-outline", link: "/pages/astral/categorias" });
    }

    if (this.menuAstral.length > 0) {
      this.menu[4].hidden = false;
    }
  }

  modalSessaoExpirada() {
    this.sessionExpiry.showSessionExpiredModal();
  }
}
